module.exports = __webpack_public_path__ + "img/daidi-loading.be21da58.gif";